export const extensionSlots = {
	userSummaryExtension: 'urn:sfextslot:pilet:user-summary-extension' as const,
	dashboardSplashExtension: 'urn:sfextslot:pilet:dashboard-splash-extension' as const,
	userProfileExtension: 'urn:sfextslot:pilet:user-profile-extension' as const,
	aiAgentConfigsExtension:
		'urn:sfextslot:safregistry:ai-agent-configs-extension' as const,
};

export interface UserData {
	id: string;
	name: string;
	department: string;
	email?: string;
}

export interface EmptyParams {}

export interface UserSummaryExtensionParams {
	selectedUsers: UserData[];
	totalAvailable: number;
	onUserSelect?: (user: UserData) => void;
}

export interface ExampleFormProps {
	userId: string;
	accountId: string;
}

export interface UserProfileExtensionParams {
	userId: string;
	accountId: string;
}

export interface AiAgentConfigsExtensionParams {
	submitEventName: string;
	onSaved?: (success: boolean, error?: any) => void;
	onFetchError?: (error: any) => void;
}

declare module '@sharefiledev/sharefile-appshell' {
	interface PiralCustomExtensionSlotMap {
		[extensionSlots.userSummaryExtension]: UserSummaryExtensionParams;
		[extensionSlots.dashboardSplashExtension]: EmptyParams;
		[extensionSlots.userProfileExtension]: UserProfileExtensionParams;
		[extensionSlots.aiAgentConfigsExtension]: AiAgentConfigsExtensionParams;
	}
}
